import { EllipsisText, type GridColDef } from '@shared/components';
import { dayjs } from '@shared/utils';

import { ExtendedDurationCell } from '../extended-duration-cell';

import { type ExamineeColumn } from './types';

export const columns: GridColDef<ExamineeColumn>[] = [
  {
    field: 'seatNumber',
    headerName: 'เลขที่นั่ง',
    width: 78,
    sortable: false,
    align: 'center',
    renderCell: ({ row }) => row.seatNumber ?? '-',
  },
  {
    field: 'fullName',
    headerName: 'ชื่อ - นามสกุล',
    flex: 1,
    minWidth: 214,
    sortable: false,
    renderCell: ({ row }) => {
      const { title, firstName, middleName, lastName } = row;

      return (
        <EllipsisText>
          {[title, firstName, middleName, lastName].filter(Boolean).join(' ')}
        </EllipsisText>
      );
    },
  },
  {
    field: 'examCourseCode',
    headerName: 'หลักสูตร',
    sortable: false,
    width: 120,
  },
  {
    field: 'manualExtendedDurationInMs',
    headerName: 'ทดโดยผู้คุม',
    width: 108,
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: ({ row, value }) => (
      <ExtendedDurationCell value={value} disabled={!row.isExtendable} />
    ),
  },
  {
    field: 'autoExtendedDurationInMs',
    headerName: 'ทดโดยระบบ',
    width: 108,
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: ({ row, value }) => (
      <ExtendedDurationCell value={value} disabled={!row.isExtendable} />
    ),
  },
  {
    field: 'remainingExtendableDurationInMs',
    headerName: 'เวลาทดคงเหลือ',
    width: 128,
    align: 'right',
    headerAlign: 'right',
    sortable: false,
    renderCell: ({ row, value }) => (
      <ExtendedDurationCell value={value} disabled={!row.isExtendable} />
    ),
  },
  {
    field: 'endTime',
    headerName: 'หมดเวลา',
    width: 104,
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    renderCell: ({ row }) => `${dayjs(row.endTime).format('HH:mm')} น.`,
  },
  {
    field: 'status',
    headerName: 'สถานะ',
    sortable: false,
    width: 144,
  },
];
